import React, { useState, useCallback, useLayoutEffect } from "react";
import HttpAction from "modules/utils/HttpAction";
import {useHistory} from "react-router-dom";

/* @INFO
* /member/team - delete : 삭제하는 아이디가 팀장인 경우 다음 팀원에게 자동으로 위임
* /member/team - post : 수동으로 특정 멤버에게 위임
* */

const TeamContext = React.createContext({
  state: {
    team: {},
    teamNameChk: null,
    // joinContestList: [],
  },
  actions: {
    getTeam: () => {},
    addMember: () => {},
    deleteMember: () => {},
    updateLeader: () => {},
    teamNameCheck: () => {},
    // getJoinContest: () => {}
  },
});

const TeamProvider = ({ children }) => {
  const [team, setTeam] = useState({});
  // const [joinContestList, setJoinContestList] = useState([]);
 const [teamNameChk, setTeamNameChk] = useState(null);
  const history = useHistory();

  // 팀명 중복 체크
  const teamNameCheck = useCallback((teamName) => {
    console.log(">> teamNameCheck: ", teamName)
    setTeamNameChk(null);
    HttpAction({
      url: "/member/team/check",
      method: "get",
      params: {
        teamName : teamName ,
      }
    }).then((res) => {
      if (res.code === 200) {
        console.log(res)
        setTeamNameChk(res)
      } else {
        setTeamNameChk(res)
      }
    }).catch(e => {
      // alert(e)
      sessionStorage.removeItem("jwt");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("loginid");
      let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
      // document.location.href = "/main"
    });
  }, []);


  // 팀 정보 조회
  const getTeam = useCallback((contestId, teamId) => {
    HttpAction({
      url: "/member/team",
      method: "get",
      params: {
        contestId: contestId,
        teamId: teamId
      }
    }).then((res) => {
      if (res.code === 200) {
        setTeam(res.data);
      } else {
      }
    }).catch(e => {
      // alert(e)
      sessionStorage.removeItem("jwt");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("loginid");
      let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
      // document.location.href = "/main"
    });
  }, []);

  //부서 조회
  // const getJoinContest = useCallback((params) => {
  //   HttpAction({
  //     url: "/admin/user/joincontest",
  //     method: "get",
  //     params: {
  //       page: params && params.page,
  //       records: params && params.records,
  //       useFlg: params && params.useFlg
  //     }
  //   }).then((res) => {
  //     if (res.code === 200) {
  //       console.log("getContestList ::: ", res.data);
  //       setJoinContestList(res.data);
  //     } else {
  //       console.log("Error")
  //     }
  //   });
  // }, []);


  // 콘테스트 팀원 추가
  const addMember = useCallback((params) => {
    HttpAction({
      url: "/member/team",
      method: "put",
      data: {
        contestId: params && params.contestId,
        memberId: params && params.memberId,
        teamId: params && params.teamId
      }
    }).then((res) => {
      if (res.code === 200) {
        getTeam(params.contestId, params.teamId)
      } else {
        console.log("error!")
      }
    }).catch(e => {
      // alert(e)
      sessionStorage.removeItem("jwt");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("loginid");
      let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
      // document.location.href = "/main"
    });
  }, [])

  // 콘테스트 팀원 삭제
  const deleteMember = useCallback((params) => {

    console.log("deleteMember params ::: ", params)



    HttpAction({
      url: "/member/team",
      method: "delete",
      params: {
        contestId: params && params.contestId,
        memberId: params && params.memberId,
        teamId: params && params.teamId
      }
    }).then((res) => {
      console.log('res', res)
      if (res.code === 200) {
        alert("대회참여가 취소되었습니다.")
        getTeam(params.contestId, params.teamId)
        /*document.location.href = "/application/mypage"*/
      } else {
        console.log("error!")
      }
    }).catch(e => {
      // alert(e)
      sessionStorage.removeItem("jwt");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("loginid");
      let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
      // document.location.href = "/main"
    });
  }, [])

  // 콘테스트 팀장 위임
  const updateLeader = useCallback((params) => {
    console.log("updateLeader params ::: ", params);
    HttpAction({
      url: "/member/team",
      method: "post",
      params: {
        contestId: params&&params.contestId,
        teamId : params&&params.teamId ,
        teamRepMberId : params&&params.teamRepMberId ,
        memberId : params&&params.memberId ,
      }
    }).then((res) => {
      if (res.code === 200) {
        getTeam(params.contestId, params.teamId);
        alert("위임되었습니다")
        console.log("success!")
      } else {
        alert("에러가 발생핬습니다.")
        console.log("error!", res)
      }
    });
  }, [])

  useLayoutEffect(() => {
    console.log('team context layout effect')
  }, []);

  const value = {
    state: { team, teamNameChk },
    actions: { getTeam,  addMember, deleteMember, updateLeader, teamNameCheck},
  };

  return (
    <TeamContext.Provider value={value}>
      {children}
    </TeamContext.Provider>
  );
};

const { Consumer: TeamConsumer } = TeamContext;

export { TeamProvider, TeamConsumer, TeamContext };

export default TeamContext;
